import Axios from 'axios';

class ModellApi {

    constructor() {
        this.api = Axios.create({
            baseURL: '/api/ProductSelector'
        });
    }

    getModelSelectorSetup() {
        return this.api.post('/GetModelSelectorData');
    }
    getProductSelector(modelType, level, selectors) {
        return this.api.post('/GetProductSelector', { ModelType: modelType, level: level, selectors: selectors });
    }

    getPlid(modelType, selectors) {
        return this.api.post('/GetPids', { ModelType: modelType, selectors: selectors });
    }

    saveMyModels(modelType, models){
        return this.api.post('/SaveModelsToPreferences', {ModelType : modelType, Models : models});
    }

    getMyModels(modelType){
        return this.api.post('/GetMyModelsFromPreferences', {ModelType : modelType});
    }

    GetModelSelectorData(){
        return this.api.post('/GetModelSelectorData');
    }

    getIsAccessoryToList(plid) {
        return this.api.get('/ListProductsThisProductIsCompatibleWith', { params: { plid: plid } });
    }

    getRedirectData(group1, group2, group3) {
        return this.api.post('/GetRedirectData', { Group1: group1, Group2: group2, Group3: group3 });
    }
}
 
export default new ModellApi();